import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ChevronUpIcon } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import parseHtmlToReact from 'html-react-parser';
import PropTypes from 'prop-types';

import { Col, ContentWrap, Grid, IncludeContent, Parameter, Section, SectionGroup } from 'bricks';
import { isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';
import {
  getBriefCharacteristicsLeft,
  getBriefCharacteristicsRight,
  getDescription,
  getDetailedSplitted,
  getDetailsIsTariffFlag,
  getFeedbackTabAvailability,
} from 'store/ProductDetails/selectors';
import commonStyles from 'styles/common.pcss';

import styles from './styles.pcss';

const cx = classNames.bind(commonStyles);
const scx = classNames.bind(styles);

const ProductDetailedCharacteristics = ({ detailedSplitted, isMobile }) => {
  const [isShow, setIsShow] = useState(false);

  function toggleShow() {
    if (isShow) {
      setIsShow(false);
    } else {
      setIsShow(true);
    }
  }

  return (
    <div>
      <div
        className={scx('headerWrap', 'dropdown')}
        onClick={() => toggleShow()}
        role="button"
        tabIndex={0}
      >
        <div className={scx('title', isMobile && 'mobile')}>Подробные характеристики</div>
        {isMobile}
        <ChevronUpIcon
          className={scx(!isShow && 'arrow', isMobile && 'mobile', isShow && 'rotate')}
        />
      </div>
      {isShow && (
        <div>
          {detailedSplitted.map(({ group, list }) => (
            <div className={scx('line')} key={group}>
              <div className={scx('head')}>{group}</div>
              {list.left.map(({ label, tip, url, value }, index) => (
                <div className={scx('row', isMobile && 'rowMobile')}>
                  <Parameter
                    isLast={index === list.left.length - 1}
                    isMobile={isMobile}
                    key={label}
                    label={label}
                    tip={tip ? parseHtmlToReact(tip) : null}
                    url={url}
                  >
                    {value}
                  </Parameter>
                  <div className={scx('space', isMobile && 'mobileSpace')} />
                  <Parameter
                    isLast={
                      (index === list.left.length - 1 && !list?.right[index]) ||
                      index === list.right.length - 1
                    }
                    isMobile={isMobile}
                    key={list?.right[index]?.label}
                    label={list?.right[index]?.label}
                    tip={list?.right[index]?.tip ? parseHtmlToReact(list?.right[index]?.tip) : null}
                    url={list?.right[index]?.url}
                  >
                    {list?.right[index]?.value}
                  </Parameter>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

ProductDetailedCharacteristics.propTypes = {
  detailedSplitted: PropTypes.array,
  isMobile: PropTypes.bool,
};

const CharacteristicsTab = ({ briefLeft, briefRight, description, detailedSplitted, isMobile }) => {
  const checkDescriptionContent = (text) => {
    if (text) {
      const reForTags = /<[^>]*>/g;
      const reNotOnlyWhiteSpace = /\S/g;
      const replacedText = text.replace(reForTags, '');
      return reNotOnlyWhiteSpace.test(replacedText);
    }
    return false;
  };

  return (
    <ContentWrap size={['xl']}>
      <Grid>
        <Col className={cx('body')} l={12} size={12}>
          <SectionGroup>
            {briefLeft.length || briefRight.length ?
              <div>
                <div className={scx('title', isMobile && 'mobile')}>Основные характеристики</div>
                <div className={scx('col')}>
                  {briefLeft.map(({ label, url, value }, index) => (
                    <div className={scx('row', isMobile && 'rowMobile')}>
                      <Parameter
                        isFirst={index === 0}
                        isLast={index === briefLeft.length - 1}
                        key={label}
                        label={label}
                        url={url}
                      >
                        {value}
                      </Parameter>
                      <div className={scx('space', isMobile && 'mobileSpace')} />
                      <Parameter
                        isLast={
                          (index === briefLeft.length - 1 && !briefRight[index]) ||
                          index === briefRight.length - 1
                        }
                        key={briefRight[index]?.label}
                        label={briefRight[index]?.label}
                        url={briefRight[index]?.url}
                      >
                        {briefRight[index]?.value}
                      </Parameter>
                    </div>
                  ))}
                </div>
              </div>
            : null}
            <ProductDetailedCharacteristics {...{ detailedSplitted, isMobile }} />
            {checkDescriptionContent(description) ?
              <Section
                title={
                  <div>
                    <div className={scx('descriptionHeader', isMobile && 'mobile')}>
                      Описание товара
                    </div>
                  </div>
                }
              >
                <IncludeContent
                  className={cx('marb-s', 'beelineFont')}
                  htmlContent={`<div itemprop="description">${description}</div>`}
                />
              </Section>
            : <meta content={null} itemProp="description" />}
          </SectionGroup>
        </Col>
      </Grid>
    </ContentWrap>
  );
};

CharacteristicsTab.propTypes = {
  briefLeft: PropTypes.array,
  briefRight: PropTypes.array,
  description: PropTypes.string,
  detailedSplitted: PropTypes.array,
  hasFeedbackTab: PropTypes.bool,
  isMobile: PropTypes.bool,
  isTariff: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  briefLeft: getBriefCharacteristicsLeft(state),
  briefRight: getBriefCharacteristicsRight(state),
  description: getDescription(state),
  detailedSplitted: getDetailedSplitted(state),
  hasFeedbackTab: getFeedbackTabAvailability(state),
  isMobile: isScreenBelow1004(state),
  isTariff: getDetailsIsTariffFlag(state),
});

export default connect(mapStateToProps)(CharacteristicsTab);
